import brand, { BrandColours } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 11px;
`;
const Tag = styled.div `
  display: flex;

  &[data-theme=${BrandColours.BlueDark}] {
    --tagColour: ${brand.primary.blue.dark};
    --textColour: ${brand.global.white};
  }

  &[data-theme=${BrandColours.BlueLight}] {
    --tagColour: ${brand.primary.blue.light};
    --textColour: ${brand.primary.blue.dark};
  }

  &[data-theme=${BrandColours.PurpleDark}] {
    --tagColour: ${brand.primary.purple.dark};
    --textColour: ${brand.global.white};
  }

  &[data-theme=${BrandColours.PurpleLight}] {
    --tagColour: ${brand.primary.purple.light};
    --textColour: ${brand.global.white};
  }

  &[data-theme=${BrandColours.OrangeMid}] {
    --tagColour: ${brand.secondary.orange.mid};
    --textColour: ${brand.global.white};
  }

  &[data-theme=${BrandColours.GreyPrimary}] {
    --tagColour: ${brand.primary.grey};
    --textColour: ${brand.primary.purple.dark};
  }

  [data-is-featured='true'][data-has-image='false'] & {
    &[data-theme=${BrandColours.PurpleDark}] {
      --tagColour: transparent;
      border: 1px solid ${brand.global.white};
    }

    &[data-theme=${BrandColours.PurpleLight}] {
      --tagColour: transparent;
      border: 1px solid ${brand.global.white};
    }
  }

  background-color: var(--tagColour);
  color: var(--textColour);

  padding: ${fluid(6, 6)} ${fluid(10, 14)};
  border-radius: 300000000px;
`;
const TagInner = styled.div `
  display: flex;
  gap: 4px;
  align-items: center;
`;
const TagIcon = styled.div `
  flex: 1 0 20px;
  height: 20px;
  width: 20px;
`;
const TagText = styled.span `
  ${fonts.lato.bold};

  display: block;
  font-size: ${fluid(12, 14)};
  line-height: ${fluid(14, 20)};
  text-transform: uppercase;
  flex: 1 0 auto;
`;
const CategoryTagsStyles = {
    Container,
    Tag,
    TagIcon,
    TagInner,
    TagText,
};
export default CategoryTagsStyles;
